import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { TdoSubnavItemModel } from '../tdo-subnav/models/tdo-subnav-item.model';
import { TdoSubnavEvent } from '../tdo-subnav/tdo-subnav.event';
import { TdoSubnavItemComponent } from '../tdo-subnav/tdo-subnav-item/tdo-subnav-item.component';
import { MenuConfigurationModel } from '../../../models/ui/menu/menu-configuration.model';
import { UiService } from '../../../services/ui.service';
import { Globals } from '../../../globals';
import { MenuItemConfigurationModel } from '../../../models/ui/menu/menu-item-configuration.model';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DialogService } from '../../../services/dialog.service';
import { AuthenticationService } from '../../../modules/auth/services/authentication.service';
import { MessagingService } from 'src/app/services/messaging.service';
import { UserRoleEnum } from 'src/app/models/enum/user-role.enum';
import { MatDialog } from '@angular/material/dialog';
import { ArInsurancePaymentComponent } from 'src/app/modules/ar/payment/ar-insurance-payment/ar-insurance-payment.component';

@Component({
  standalone: false,
  selector: 'app-tdo-smartnav',
  templateUrl: './tdo-smartnav.component.html',
  styleUrls: ['./tdo-smartnav.component.scss']
})
export class TdoSmartnavComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() menuName: string;
  @Input() mainContainer: HTMLDivElement;
  @Input() navbarMaxItems: number = 6;
  @Input() dataSource: TdoSubnavItemModel[] = [];
  @Input() currentRoute: string;

  @Output() selected = new EventEmitter<TdoSubnavEvent>();

  @ViewChildren(TdoSubnavItemComponent) navItems: QueryList<TdoSubnavItemComponent>;

  private readonly destroy$ = new Subject<void>();

  isShowMenu: boolean = false;
  usageItems: MenuItemConfigurationModel[] = [];
  navbarItems: TdoSubnavItemModel[] = [];
  hamburgerItems: TdoSubnavItemModel[] = [];
  isReady = false;

  width = 0;

  menu: MenuConfigurationModel;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkSize();
    // Extra check for cases where the browser is resized from double clicking the top bar instead of dragging with the mouse.  This
    // Fixes a bug where the navbar would be empty in this case.
    setTimeout(() => {
      this.checkSize();
    }, 10);
  }

  constructor(private uiService: UiService, private globals: Globals, private router: Router, private dialogService: DialogService,
    private messagingService: MessagingService, private authService: AuthenticationService, private cdr: ChangeDetectorRef,
    private dialog: MatDialog) {

  }

  ngOnInit(): void {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(e => {
      if (e instanceof NavigationEnd) {
        this.syncSelectionToRoute(e.urlAfterRedirects);
      }
    });

    if (this.menuName) {
      this.uiService.getMenu('Main').subscribe((res) => {
        this.menu = res;
        if (this.menu) {
          this.uiService.getUserMostUsedMenuItems(this.menu.MenuID, this.authService.currentUserValue?.authdata?.userid).subscribe((userRes) => {
            this.usageItems = userRes;

            for (const mi of this.menu.cfgMenuItems) {
              if (this.isUserHasRole(mi.cfgMenuMasterItem.MenuItemName.toLowerCase())) {

                const sim = new TdoSubnavItemModel(mi.cfgMenuMasterItem.MenuItemName);
                sim.route = mi.cfgMenuMasterItem.CommandRout;
                sim.itemId = mi.MenuItemId;
                sim.menuId = mi.MenuID;
                this.dataSource.push(sim);
              }

            }
            this.usageItems = this.usageItems.filter(p => this.dataSource.map(e => e?.label).includes(p.cfgMenuMasterItem.MenuItemName));

            setTimeout(() => {
              this.isReady = true;
              this.checkSize();
              this.cdr.markForCheck();
            }, 0);
          });
        }
      });
    }
  }

  isUserHasRole(menu: string) {
    switch (menu) {
      case 'letters':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.Letters);
      case 'case view':
      case 'medical history':
      case 'pain history':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.CaseMgmt) || this.authService.currentUserRolesIds.includes(UserRoleEnum.CaseMgmtViewOnly);
      case 'ledger':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.Ledger);
      case 'fees':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.Fees);
      case 'claims':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.InsuranceClaimsMgmt);
      case 'organizer':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.ImageOrganizer);
      case 'studio':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.ImagingStudio);
      case 'imaging center':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.ImagingCenter);
      case 'erx':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.Erx);
      case 'treatmentPlan':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.TreatmentPlanning);
      case 'visit':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.VisitWizard);
      case 'insurance payment':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.PaymentFromInsurance);
      case 'payment audit':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.PaymentAudit);
      case 'reporting':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.Reports);
      case 'referring doctors':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.Configuration);
      case 'accounting sync.':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.EnterpriseAccountIntegration);
      case 'insurance':
        return this.authService.currentUserRolesIds.includes(UserRoleEnum.Insurance) || this.authService.currentUserRolesIds.includes(UserRoleEnum.InsuranceViewOnly);
        case 'data import':
          return this.authService.currentUserRolesIds.includes(UserRoleEnum.DataImport);
      default:
        return true;
    }
  }
  checkSize() {
    this.width = this.mainContainer.getBoundingClientRect().width;
    if (this.mainContainer) {
      const amountCanHoldTotal = Math.floor((this.mainContainer.getBoundingClientRect().width / 80));
      const navbarPreferredItems = this.usageItems.map(p => {
        const item = new TdoSubnavItemModel(p.cfgMenuMasterItem.MenuItemName);
        item.route = p.cfgMenuMasterItem.CommandRout;
        item.itemId = p.MenuItemId;
        item.menuId = p.MenuID;
        return item;
      });

      this.navbarItems = [];
      if (navbarPreferredItems && navbarPreferredItems.length > 0) {
        for (let i = 0; i < amountCanHoldTotal; i++) {
          if (!this.navbarItems.includes(navbarPreferredItems[i])) {
            this.navbarItems.push(navbarPreferredItems[i]);
          }
        }
      }
      // Add all remaining to the burger menu
      this.hamburgerItems = this.dataSource.filter(p => !this.navbarItems.map(e => e?.label).includes(p?.label));
    } else {
      //
    }
  }

  ngAfterViewInit(): void {
    this.handleInitialSelection();
    this.checkSize();
    if (this.navItems && this.navItems.length > 0) {
      //
    } else {
      const ivl = setInterval(() => {
        // We must wait for the @ContentChildren to be available
        if (this.navItems && this.navItems.length > 0) {
          clearInterval(ivl);
        }
      }, 200);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private syncSelectionToRoute(url: string): void {
    if (!this.navItems) return;
    // Strip query string and fragment so URLs like /landing/patient-insurance?foo=bar match correctly.
    const path = url.split('?')[0].split('#')[0];
    this.navItems.forEach(p => p.isSelected = false);
    // Match by the item's configured route rather than the URL segment name, so tabs
    // whose route path differs from their display label (e.g. "Insurance" → /landing/patient-insurance)
    // are selected correctly on the first click.
    const match = this.navItems.find(p => {
      const itemPath = p.model?.route?.split('?')[0].split('#')[0];
      return itemPath && path.endsWith(itemPath);
    });
    if (match) match.isSelected = true;
  }

  handleInitialSelection() {
    if (this.currentRoute.includes('/')) {
      const ivl = setInterval(() => {
        if (this.navItems != null) {
          clearInterval(ivl);
          // Strip query string and fragment, then match by configured route path
          // (same logic as syncSelectionToRoute) so tabs like "Insurance" whose route
          // differs from the URL segment name are selected correctly on initial load.
          const path = this.currentRoute.split('?')[0].split('#')[0];
          const item = this.navItems.find(p => {
            const itemPath = p.model?.route?.split('?')[0].split('#')[0];
            return itemPath && path.endsWith(itemPath);
          });
          if (item) {
            item.select();
          }
        }
      }, 100);
    }
  }

  onSubnavItemSelected(event: TdoSubnavEvent) {
    for (const item of this.navItems) {
      if (item !== event.model) {
        item.isSelected = false;
      }
    }
    this.selected.emit(event);
  }

  handleHamburgerSelection(item: TdoSubnavItemModel) {
    this.isShowMenu = false;

    this.navItems.map(p => p.isSelected = false);

    const model = new TdoSubnavEvent(item.label, null);
    this.selected.emit(model);
  }

  onMenuClick() {
    this.isShowMenu = !this.isShowMenu;
  }

  onHamburgerItemMouseEnter(event: MouseEvent, item: TdoSubnavItemModel) {
    if (item.children.length > 0) {
      item.isShowMenu = true;
    }
  }

  onHamburgerItemLeave(event: MouseEvent, item: TdoSubnavItemModel) {
    item.isShowMenu = false;
  }

  onItemClicked(item: TdoSubnavItemModel) {
    this.uiService.updateMenuUsage(this.authService.currentUserValue.authdata.userid, item.itemId).subscribe(() => {
      //
    });
    this.isShowMenu = false;
    if (item.route) {
      if (item.route.startsWith('/configuration')) {
        let windowOptions = [
          'toolbar=no',
          'location=no',
          'menubar=no',
          'height=' + screen.height,
          'width=' + screen.width,
          'fullscreen=yes' // only works in IE, but here for completeness
        ].join(',');
        let storageName = item.label;
        let itemToStore = {};
        let postClosureEvents = [];

        this.messagingService.openPopUpWindow(item.route, windowOptions, storageName, itemToStore, postClosureEvents, true, item.label);
      }
      else if (this.isInsurancePaymentRoute(item.route)) {
        // ArInsurancePaymentComponent is a dialog-only component (requires a MatDialogRef),
        // so it must be opened via MatDialog rather than navigated to as a page.
        this.openInsurancePaymentDialog();
      }
      else {
        this.router.navigateByUrl(item.route);
      }
    } else {
      // Must be a popup or external link (i.e. letters, pain history)
      switch (item.label) {
        case 'Letters':
          this.uiService.openLettersWindow();
          break;
        case 'Accounting Sync.':
          this.uiService.openAccountingIntegrationWindow(true);
          break;
        case 'Imaging Center':
          this.uiService.openImagingCenterWindow(true);
          // const imagingCenterWindow = window.open('/collage', '_blank', 'toolbar=1,location=1,menubar=1,noopener,noreferrer');
          // if (imagingCenterWindow) imagingCenterWindow.opener = null;
          break;
        case 'Studio':
          this.uiService.openImagingWindow(true);
          break;
        case 'Medical History':
          this.dialogService.openMedicalHistory(this.globals.currentPatientId);
          break;
        case 'Pain History':
          this.dialogService.openPainHistory(this.globals.currentPatientId);
          break;
        case 'Reporting':
          this.uiService.openReportWindow();
          break;
        case 'Referral Manager':
          this.uiService.openReferralWindow();
          break;
      }
    }
  }

  private isInsurancePaymentRoute(route: string): boolean {
    // Strip query string/fragment and leading/trailing slashes, same normalization used by
    // syncSelectionToRoute/handleInitialSelection, so variants like '/landing/insurance-payment/'
    // or 'landing/insurance-payment?x=1' still match instead of falling through to navigateByUrl.
    const normalized = route?.split('?')[0].split('#')[0].replace(/^\/+|\/+$/g, '').toLowerCase();
    return normalized === 'landing/insurance-payment';
  }

  openInsurancePaymentDialog() {
    this.dialog.open(ArInsurancePaymentComponent, {
      width: '90%',
      height: '875px',
      panelClass: 'dialog',
      disableClose: true, // prevents dialog closing as a result of an outside click
      data: {}
    });
  }
}
